import { useState, useEffect } from 'react';

interface SlideshowItem {
  imageUrl: string;
  caption?: string;
}

interface BackgroundSlideshowProps {
  items: SlideshowItem[];
  cycleInterval?: number; // ms, default 20000
}

export function BackgroundSlideshow({ items, cycleInterval = 20000 }: BackgroundSlideshowProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % items.length);
    }, cycleInterval);
    return () => clearInterval(timer);
  }, [items.length, cycleInterval]);

  useEffect(() => {
    if (items.length > 0 && currentIndex >= items.length) {
      setCurrentIndex(0);
    }
  }, [items.length, currentIndex]);

  if (items.length === 0) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
      }}
    >
      {items.map((item, index) => (
        <div
          key={item.imageUrl}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${item.imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: index === currentIndex ? 1 : 0,
            transition: 'opacity 1.5s ease',
          }}
        />
      ))}
      {/* Dark overlay for text readability */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(13, 27, 18, 0.7)',
        }}
      />
      {/* Caption */}
      {items[currentIndex]?.caption && (
        <div
          style={{
            position: 'absolute',
            bottom: 24,
            left: 24,
            padding: '8px 16px',
            background: 'rgba(0, 0, 0, 0.6)',
            borderRadius: 4,
            color: '#e0e0e0',
            fontSize: '14px',
            fontFamily: "'Inter', system-ui, sans-serif",
            zIndex: 1,
          }}
        >
          {items[currentIndex].caption}
        </div>
      )}
    </div>
  );
}
